<template>
	<div>	
		<template v-if="device!='pc'">
			<van-field :required="formCreateInject.rule.validate.required" readonly clickable
				:label="formCreateInject.prop.title.title" :value="textValue" placeholder="" @click="showPicker = true"
				input-align="right" />
			<van-popup v-model="showPicker" round position="bottom">
				<van-picker value-key="label" show-toolbar :title="formCreateInject.prop.title.title" :columns="options" @cancel="showPicker = false"
					@confirm="onConfirm" />
			</van-popup>
		</template>
		<template v-else>
			<template v-if="!renderCell">
				<div :class="{readonly:readonly}">
					<el-select :value="value" :size="size" :placeholder="placeholder" :disabled="disabled" @change="change"
						clearable transfer filterable>
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</template>
			<template v-else>
				<span>{{textValue}}</span>
			</template>
		</template>
	</div>
</template>

<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
			cdsign: {
				default: () => {
					return null
				}
			},
			fromModule: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				ready: false,
				sourceData: [],
				options: [],
				showPicker: false,
				device: window.systemMethods.device()
			}
		},
		created() {

		},

		computed: {
			textValue() {
				let text = ''
				if (Array.isArray(this.value)) {
					let options = []
					let arr = []
					options = this.options
					this.value.forEach((item) => {
						for (let i = 0; i < options.length; i++) {
							if (options[i].value == item) {
								arr.push(options[i].label)
								options = options[i].children ? options[i].children : []
								break
							}
						}

					})
					text = arr.join('/')
				} else {

					for (let i = 0; i < this.options.length; i++) {
						if (this.options[i].value == this.value) {
							text = this.options[i].label
							break
						}
					}
				}
				return text
			}
		},

		methods: {
			onConfirm(value, index) {
				if (value) {
					let postvalue = ''
					if (Array.isArray(value)) {
						let currentobj = this.options
						let objarr = []
						index.forEach((item) => {
							objarr.push(currentobj[item])
							currentobj = currentobj[item].children
						})
						postvalue = objarr.map((item) => {
							return item.id
						})
					} else {
						postvalue = value.value
					}
					this.change(postvalue)
				}
				this.showPicker = false
			},
			list() {
				if (!window.systemData.bankaccount) {
					this.$api.bankaccount.list({
						currentPage: -1
					}).then((res) => {
						let options = []
						res.list = res.list.filter((item)=>{
							return item.enable == 1
						})
						if(this.cdsign){
							res.list = res.list.filter((item)=>{
								return item.cdsign == this.cdsign || item.cdsign == '全部'
							})
						}
						res.list.forEach((item) => {
							options.push({
								value: item.id,
								label: this.formatterLabel(item)
							})
						})
						this.setOptions(options)
						this.finish()
					})
				} else {
					let list = JSON.parse(JSON.stringify(window.systemData.bankaccount))
					let options = []
					list = list.filter((item)=>{
						return item.enable == 1
					})
					if(this.cdsign){
						list = list.filter((item)=>{
							return item.cdsign == this.cdsign || item.cdsign == '全部'
						})
					}
					
					list.forEach((item) => {
						options.push({
							value: item.id,
							label: item.name
						})
					})
					this.setOptions(options)
					this.finish()
				}
			},
			setOptions(options){
				if(this.fromModule == 'supplier'){
					this.$api.bankaccount.list({
						type: 'localaccount',
						special: 'supplier'
					}).then((res) => {
						let bankaccount = res.list
						this.options  = options.filter((item) =>{
							return bankaccount.some((_item) => {return _item.id == item.value} )
						})		
					})
				}else{
					this.options = options
				}
				
			},
			formatterLabel(item){
				let arr = []
				let accountbusiness = window.systemMethods.getEmunValue('accountbusiness',item.accountbusiness)
				let suppliersettlementtype = window.systemMethods.getEmunValue('suppliersettlementtype',item.suppliersettlementtype)
				arr.push(item.inst_account)
				arr.push(item.acc_name)				
				if(accountbusiness){
					arr.push(accountbusiness)
				}
				if(suppliersettlementtype){
					arr.push(suppliersettlementtype)
				}
				if(item.iscaizi == 1){
					arr.push('财资')
				}
				
				return arr.join('/')
			}
		}
	}
</script>
<style scope>
	.readonly{
		pointer-events: none;
	}
	.readonly .el-input__suffix-inner{
		pointer-events: none;
	}
</style>